(function () {
    'use strict';

    angular
        .module('virtualFairs')
        .controller('PhysicalFairLeadsBoothController', PhysicalFairLeadsBoothController);
        PhysicalFairLeadsBoothController.$inject = ['PlatformRentalService', 'PhysicalFairService', '$timeout', 'isPlatformRental', 'physicalFairs'];
    function PhysicalFairLeadsBoothController(PlatformRentalService, PhysicalFairService, $timeout, isPlatformRental, physicalFairs) {
        var vm = this;

        vm.selectVirtualFairs    = selectVirtualFairs;
        vm.getByFilter           = getByFilter;
        vm.activate              = activate;
        vm.physicalFairSelected  = '';
        vm.flag                  = false;
        vm.orderBy               = orderBy;
        vm.query                 = {};
        vm.downloadCSV           = downloadCSV;
        vm.downloadExhibitorLeadsCSV = downloadExhibitorLeadsCSV;

        /*PAGINATION*/
        vm.pageChanged           = pageChanged;
        vm.setPage               = setPage;
        vm.to                    = [];
        vm.totalItems            = [];
        vm.currentPage           = null;
        vm.itemsPerPage          = [];
        vm.page                  = 1;
        vm.isPlatformRental      = isPlatformRental;
        vm.physicalFairs          = physicalFairs;

        console.log("Physical Fairs Select", physicalFairs)

        function selectVirtualFairs () {
            // if(virtualFairs) {
            //     vm.virtualFairs = virtualFairs;
            // } else {
            //     let query ={}
            //     query['with_stats'] = 1;
            //     query['order_by'] = 'DESC';
            //     VirtualFairService.getAll(query).then(function(response) {
            //         vm.virtualFairs = response.data;
            //     });
            // }
        }

        function getByFilter (reset = false) {
            if(reset) {
                vm.query = {};
            }
            vm.flag = false;
            vm.query['expo_id'] = vm.physicalFairSelected;
            if (vm.page !== null) {
                vm.query['page'] = vm.page;
            }
            if(vm.isPlatformRental) {
                vm.query['platform-rental'] = 1;
            }
            PhysicalFairService.getLeadsBooth(vm.query).then(function(response) {
                vm.flag = true;
                vm.leadsBooth = response.data.data;
                vm.totalItems = response.data.total;
                vm.to = response.data.to;
                vm.setPage(response.data.current_page);
                vm.itemsPerPage = response.data.per_page;
            });
        }

        function setPage (pageNo) {
            vm.currentPage = pageNo;
        }

        function pageChanged (pageNo) {
            vm.page = vm.currentPage;
            vm.getByFilter();
        }

        function orderBy (column) {
            if((typeof vm.query['order'] === 'undefined') || (!vm.query['order'])) {
                vm.query['order'] = 'asc';
            } else {
                if(vm.query['order'] === 'asc') {
                    vm.query['order'] = 'desc';
                } else {
                    vm.query['order'] = 'asc';
                }
            }
            vm.query['orderby'] = column;
            vm.page = 1;
            vm.getByFilter();
        }

        function downloadCSV () {
            let query = {};
            query['expo_id'] = vm.physicalFairSelected;
            if(vm.isPlatformRental) {
                query['platform-rental'] = 1;
            }
            PhysicalFairService.getLeadsBoothCsv(query).success(function (data) {
                var anchor = document.createElement("a");
                anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
                anchor.target = "_blank";
                anchor.download = `physical_fair_leads_per_booth_${vm.physicalFairSelected}.csv`;
                document.body.appendChild(anchor);
                anchor.click();
                $timeout(function () {
                    anchor.remove();
                }, 50);
            });
        }

        function downloadExhibitorLeadsCSV(user_id) {

            let query = {}

            query['expo_id'] = vm.physicalFairSelected;
            query['user_id'] = user_id;

            console.log(vm.physicalFairSelected)

            if(vm.isPlatformRental) {
                query['platform-rental'] = 1;
            }
            // VirtualFairService.getExhibitorLeadsCSV(query).success(function (data) {
            //     var anchor = document.createElement("a");
            //     anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
            //     anchor.target = "_blank";
            //     anchor.download = `virtual_fair_exhibitor_leads_${vm.virtualFairSelected}.csv`;
            //     document.body.appendChild(anchor);
            //     anchor.click();
            //     $timeout(function () {
            //         anchor.remove();
            //     }, 50);
            // });
            PhysicalFairService.leadsCSV(vm.physicalFairSelected, query).success(function (data) {
              var anchor = document.createElement("a");
              anchor.href = "data:application/octet-stream;base64," + encodeURI(data);
              anchor.target = "_blank";
              anchor.download = `virtual_fair_leads_${vm.physicalFairSelected}.csv`;
              document.body.appendChild(anchor);
              anchor.click();
              vm.disableDownloadCsv = false;
              $timeout(function () {
                anchor.remove();
              }, 50);
            });
        }


        function activate () {
            vm.selectVirtualFairs();
        }

        vm.activate();
    }
})();
